import React from 'react';
import useSaveAsDraft from './useSaveAsDraftButton';
import useSaveAsDraftModal from './useSaveAsDraftModal';
import {
  FlexBox,
  FluidPrimaryButton,
  SpinnerIcon,
  Paragraph,
} from '../../../Components';
import { getTranslateByScope } from '../../../i18n';
import ConfirmModal from '../../ConfirmModal';

const translate = getTranslateByScope('app.closeOrder');

export default function SaveAsDraftButton() {
  const {
    isConfirmationModalOpen,
    setIsConfirmationModalOpen,
    isSuccessModalOpen,
    setIsSuccessModalOpen,
  } = useSaveAsDraft();

  const { isLoading, isFailedSync, confirmSaveAsDraft } = useSaveAsDraftModal({
    setIsSuccessModalOpen,
  });

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeSuccessModal = () => {
    setIsSuccessModalOpen(false);
  };
  return (
    <>
      {isLoading ? (
        <FlexBox
          flex={1}
          marginTop='md'
          justifyContent='space-around'
          alignItems='center'
        >
          <SpinnerIcon /> <Paragraph>{translate('submitting')}</Paragraph>
        </FlexBox>
      ) : (
        <FlexBox justifyContent='flex-end'>
          <FluidPrimaryButton
            onClick={openConfirmationModal}
            text={
              isFailedSync
                ? translate('syncButton')
                : translate('saveAsDraftButton')
            }
          />
        </FlexBox>
      )}

      <ConfirmModal
        isOpen={isConfirmationModalOpen}
        setIsOpen={setIsConfirmationModalOpen}
        onConfirm={confirmSaveAsDraft}
        title={translate('saveAsDraftModal.title')}
        buttonCaption={translate('saveAsDraftModal.buttonCaption')}
        description={translate('saveAsDraftModal.description')}
      />

      <ConfirmModal
        isOpen={isSuccessModalOpen}
        setIsOpen={setIsSuccessModalOpen}
        onConfirm={closeSuccessModal}
        title={translate('saveAsDraftSuccessModal.title')}
        buttonCaption={translate('saveAsDraftSuccessModal.buttonCaption')}
        description={translate('saveAsDraftSuccessModal.description')}
      />
    </>
  );
}
